export default "__VITE_ASSET__9fe79614__"